module.exports = __webpack_public_path__ + "static/media/popularityList.60a6bf90.less";